import { isNonFinancialEob } from '~/entities/categories'
import { useCurrentDocument, usePaymentSummary } from '~/entities/document'
import { getActiveClaimFlag, useDocumentFlags } from '~/entities/document-flags'
import { usePatientClaims } from '../api'
import { ProgressTracker } from './progress-tracker/progress-tracker'

export function EobProgressTrackerActions() {
  const {
    data: { document },
  } = useCurrentDocument()
  const { data: summaryData } = usePaymentSummary()
  const { data: claimsData } = usePatientClaims()
  const { data: flagsData } = useDocumentFlags()

  const isNonFinancial = isNonFinancialEob(document.category)
  const documentFlags = flagsData?.items ?? []

  const totalPaidCents = summaryData.total_paid ? Number(summaryData.total_paid) : 0
  const deductedCents = (summaryData.adjustments ?? []).reduce(
    (acc, adj) => acc + (adj.deduct_from_total_paid && adj.amount ? Number(adj.amount) : 0),
    0,
  )
  const allocatedCents = claimsData.patient_claims.reduce(
    (acc, claim) => acc + (claim.total_paid ? Number(claim.total_paid) : 0),
    0,
  )

  // Flagged claims are in "Follow Up" state — exclude from validated count
  // so they don't reduce the "to validate" counter
  const flaggedClaimCount = claimsData.patient_claims.filter(
    (claim) => getActiveClaimFlag(documentFlags, claim.key) !== null,
  ).length

  return (
    <div className="flex gap-3">
      <ProgressTracker
        totalClaims={
          summaryData.number_of_patient_claims ? summaryData.number_of_patient_claims : undefined
        }
        validatedClaims={claimsData.patient_claims.length - flaggedClaimCount}
        totalPaidCents={totalPaidCents}
        allocatedCents={allocatedCents}
        deductedCents={deductedCents}
        isNonFinancial={isNonFinancial}
      />
    </div>
  )
}
